let versionConfig = require('./../version.json');

/**
 * @return {string} - номер версии сборки
 */
function getVersion() {
    return versionConfig.version;
}

/**
 * @return {string} - краткое описание сборки
 */
function getDescription() {
    return versionConfig.description;
}

/**
 * @return {string} - json представление структуры API
 */
function getApiStructure() {
    let apiStructure = require('./../core/modules.json');
    return apiStructure.modules;
}

module.exports = {
    getVersion: getVersion,
    getDescription: getDescription,
    getApiStructure: getApiStructure
};